// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const dyeVats = defineModel({
  id: "dye-vats",
  batchId: "future",
  name: "Dye vats",
  tags: ["scenery","dye","vats","low-poly","age-of-mcp","future"],
  summary: "Vats of dye — colour for cloth, leather and paint across many goods.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.13, 0.115, 0.2, 11), color: "#6b4e2e", position: [-0.22, 0.1, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [-0.22, 0.05, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [-0.22, 0.16, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.115, 0.115, 0.02, 11), color: "#34407a", position: [-0.22, 0.195, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.115, 0.2, 11), color: "#6b4e2e", position: [0.04, 0.1, -0.06] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [0.04, 0.05, -0.06] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [0.04, 0.16, -0.06] },
      { geometry: new THREE.CylinderGeometry(0.115, 0.115, 0.02, 11), color: "#a8392f", position: [0.04, 0.195, -0.06] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.115, 0.2, 11), color: "#6b4e2e", position: [0.24, 0.1, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [0.24, 0.05, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.134, 0.134, 0.02, 11), color: "#5a4226", position: [0.24, 0.16, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.115, 0.115, 0.02, 11), color: "#cba82e", position: [0.24, 0.195, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.34, 5), color: "#7a5a36", position: [0.04, 0.18, -0.06], rotation: [0.18, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.015), color: "#7a5a36", position: [0.07, 0.04, -0.06], rotation: [0.18, 0, 0.12] },
    ],
  animations: [],
});
